export * from './src/rich-text-editor.module';
